import { z } from 'zod'

// Tag-filter URL format: a single comma-separated string, e.g.
// `?tagNames=gen3,scaling`. The schema keeps the URL value as a string —
// downstream consumers split into `string[]` via `parseTagNames`. Storing
// as an array here would make TanStack Router serialize it as JSON
// (`?tagNames=["gen3","scaling"]`), which is far less readable.
export const TAG_NAME_SEPARATOR = ','

export const parseTagNames = (raw: string | undefined): string[] => {
  if (!raw) return []
  return raw
    .split(TAG_NAME_SEPARATOR)
    .map((s) => s.trim())
    .filter(Boolean)
}

export const serializeTagNames = (
  tagNames: readonly string[],
): string | undefined =>
  tagNames.length > 0 ? tagNames.join(TAG_NAME_SEPARATOR) : undefined

export const librarySearchSchema = z.object({
  search: z.string().optional().catch(undefined),
  tagNames: z.string().optional().catch(undefined),
  tab: z.enum(['workflows', 'processes']).catch('workflows'),
  selectedId: z.string().optional().catch(undefined),
  selectedType: z.enum(['workflow', 'process']).optional().catch(undefined),
})
